module.exports = __webpack_public_path__ + "static/media/9DESA29.8649b5a2.jpg";